import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";
import MobileSticky from "@/components/landing/MobileSticky";

export default function LegalPage({ eyebrow, title, updated, children }) {
  return (
    <main className="relative bg-[#050505] text-white min-h-screen font-body">
      <Nav />

      <section className="relative pt-32 md:pt-40 pb-16 md:pb-20">
        <div
          aria-hidden
          className="absolute left-1/2 -translate-x-1/2 -top-40 w-[900px] h-[900px] rounded-full bg-emerald-500/10 blur-[140px] -z-10"
        />
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs text-white/50 hover:text-emerald-400 transition mb-8"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to home
          </Link>

          {eyebrow && (
            <div className="text-emerald-400 uppercase tracking-[0.3em] text-xs font-semibold font-display mb-4">
              {eyebrow}
            </div>
          )}

          <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
            {title}
          </h1>

          {updated && (
            <div className="mt-5 text-white/40 text-xs font-mono">
              Last updated: {updated}
            </div>
          )}
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert prose-emerald max-w-none text-white/75 leading-relaxed space-y-6">
            {children}
          </div>

          <div className="mt-16 pt-8 border-t border-white/10 text-sm text-white/50">
            Questions? Contact us at{" "}
            <a
              href="mailto:support@trade-flux.com"
              className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4"
            >
              support@trade-flux.com
            </a>
            .
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </main>
  );
}
